
export const DEFAULT_IMAGES_URL = {
    alumno: '/images/icons/alumno/default.png',
    responsable:  '/images/icons/responsable/default.png',
}